import React from "react";

import { Trans } from "app/utils";

const WidgetResponseRate = ({
  itemResponseCount,
  itemResponseCountPlural,
  overallResponseCount,
  overallResponseCountPlural,
  percentage
}) => (
  <>
    <p>
      <Trans>
        {itemResponseCount} user{itemResponseCountPlural} answered this question
      </Trans>
    </p>
    <p>
      <Trans>
        out of {overallResponseCount} survey respondent{overallResponseCountPlural} ({percentage}%)
      </Trans>
    </p>
  </>
);

const EventResponseRate = ({
  itemResponseCount,
  itemResponseCountPlural,
  overallResponseCount,
  overallResponseCountPlural,
  percentage
}) => (
  <>
    <p>
      <Trans>
        {itemResponseCount} guest{itemResponseCountPlural} answered this question
      </Trans>
    </p>
    <p>
      <Trans>
        out of {overallResponseCount} guest{overallResponseCountPlural} who
        confirmed &quot;YES&quot; ({percentage}%)
      </Trans>
    </p>
  </>
);

const getPercentage = (count, total) => (
  total === 0 ? 0 : Math.round((count / total) * 100)
);

const ResponseRate = ({ itemResponseCount = 0, overallResponseCount, potentialRespondents }) => {
  const props = {
    itemResponseCount,
    itemResponseCountPlural: itemResponseCount === 1 ? "" : "s",
    overallResponseCount,
    overallResponseCountPlural: overallResponseCount === 1 ? "" : "s",
    percentage: getPercentage(itemResponseCount, overallResponseCount)
  };

  return (
    <div className="pull-right survey-item-result__rate">
      {
        potentialRespondents === -1
          ? <WidgetResponseRate {...props} />
          : <EventResponseRate {...props} />
      }
    </div>
  );
};

export default ResponseRate;
